import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Project } from '@apps/projects/projects.state';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-project-name-display',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  template: `
    <ng-container>
      <span *ngIf="!project.isAssignedToMe" class="project-name" matTooltip="{{ project.name }}">{{ project.name }}</span>
      <a
        *ngIf="project.isAssignedToMe"
        [href]="project.sharePointLink"
        target="_blank"
        class="project-name"
        matTooltip="{{ project.name }}"
      >
        {{ project.name }}
      </a>
    </ng-container>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectNameDisplayComponent {
  @Input({ required: true }) project!: Project;
}
